import ContentfulReducer from './store/reducer'
export { getContentLayerMiddleWare } from './store/setup'
export default ContentfulReducer
